import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Meta } from '@df/core/meta/meta';
import { Client } from '@df/core/service/client';
import { OffClickDirective } from '@df/module-off-click/off-click.directive';
import { BlockScrollService } from '@df/ui/block-scroll.service';
import { BehaviorSubject } from 'rxjs';
import { OffCanvasMenuBodyComponent } from './menu/off-canvas-menu-body.component';
export const OFF_CANVASS_MENU_ZIPPY_CLOSE_EVENT = 'off-canvas-menu.zippy.close';

/**
 * Off canvas menu.
 *
 * ```html
 * <off-canvas-menu class="off-canvas off-canvas-right"></off-canvas-menu>
 * ```
 *
 * @author Rafał Wolak <rafal@tomandco.co.uk>
 * @date 2019-03-21
 * @export
 * @class OffCanvasMenuItemComponent
 */
@Component({
    selector: 'off-canvas-menu',
    templateUrl: './off-canvas-menu.html',
    styleUrls: ['./off-canvas-menu.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [OffCanvasMenuBodyComponent, CommonModule, OffClickDirective]
})
export class OffCanvasMenuComponent implements OnInit {
    @Input()
    offCanvasState?: BehaviorSubject<boolean>;

    blockScrollService = inject(BlockScrollService);
    constructor(
        private meta: Meta,
        protected client: Client,
        private changeDetectorRef: ChangeDetectorRef
    ) {
        this.meta.routerEvents.pipe(takeUntilDestroyed()).subscribe(() => this.close());
    }

    ngOnInit() {
        this.offCanvasState?.subscribe(() => {
            if (this.offCanvasState?.value) this.blockScrollService.enable(this);
            else this.blockScrollService.disable(this);
            this.changeDetectorRef.detectChanges();
        });
    }

    close(): void {
        this.offCanvasState?.next(false);
    }

    isVisible(): boolean {
        return !!this.offCanvasState?.getValue();
    }
}
